module.exports = __webpack_public_path__ + "26a82a4677ba0d32eb97d1ed4d7445c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/jewelry-photo/img/jewelry-placeholder-external@2x.png
// module id = 775
// module chunks = 0